<div class="panel-title">Details</div>
<div class="panel-content" *ngFor="let signer of contract?.signers">
  <div class="item-row">
    <div class="item-label d-flex align-items-center justify-content-between">
      <div>
        <ng-container i18n>Signer Name</ng-container>&nbsp;
        <a
          href="javascript:;"
          i18n-matTooltip
          matTooltip="copy sign link."
          *ngIf="isSignable(signer)"
          (click)="onCopySignLink(signer)"
        >
          <i [ngClass]="isGeneratingSignLink ? 'far fa-spin fa-spinner' : 'cs-icon cs-icon-copy'"></i>
        </a>
      </div>
    </div>
    <div class="item-value">
      <span [matTooltip]="signer.email" class="signer-name d-inline-block" (click)="onSignerClick(signer)">{{
        signer.name
      }}</span>
      <a
        href="javascript:;"
        class="ml-3"
        *ngIf="signer.status === signerStatuses.Signed && !!signer.photo_urls?.length"
        (click)="openPhotoID(signer)"
        i18n-matTooltip
        matTooltip="view signer's photo ID or passport."
      >
        <i class="fal fa-id-card-alt"></i>
      </a>
      <span
        class="text-capitalize signer-status ml-2 badge badge-pill text-sm"
        [ngClass]="'badge-secondary-' + status.color"
        *ngIf="signer.status | signStatus; let status"
      >
        <i [ngClass]="status.icon"> </i>
        {{ signer.status === 'sent' ? 'received' : signer.status }}
      </span>
    </div>
  </div>
  <div class="item-row" *ngIf="activities[signer.role]?.sent">
    <div class="item-label" i18n>Sent On</div>
    <div class="item-value">
      <ul class="dot-segments-list">
        <li>{{ activities[signer.role]?.sent?.date | epoch : 'DD - MMM - YYYY' }}</li>
        <li>{{ activities[signer.role]?.sent?.date | epoch : 'h:mm A' }}</li>
      </ul>
    </div>
  </div>
  <div class="item-row" *ngIf="activities[signer.role]?.signed">
    <div class="item-label" i18n>Signed on</div>
    <div class="item-value">
      <ul class="dot-segments-list">
        <li>{{ activities[signer.role]?.signed?.date | epoch : 'DD - MMM - YYYY' }}</li>
        <li>{{ activities[signer.role]?.signed?.date | epoch : 'h:mm A' }}</li>
      </ul>
    </div>
  </div>
  <div class="item-row" *ngIf="signer.status === signerStatuses.Failed && activities[signer.role]?.failed">
    <div class="item-value">
      <div class="alert alert-secondary-danger">
        <div class="alert-icon">
          <i class="fal fa-exclamation-triangle"></i>
        </div>
        <div class="alert-content" i18n>Please check if the signer's email is correct and try to resend it.</div>
      </div>
    </div>
  </div>
  <div class="item-row" *ngIf="signer.status === signerStatuses.Decline">
    <div class="item-label" i18n>Decline Reason</div>
    <div class="item-value">
      <app-show-more [content]="activities[signer.role].declined?.additional?.reason" [maxLength]="50"> </app-show-more>
    </div>
  </div>
  <div class="item-row" *ngIf="activities[signer.role]?.signed?.additional && contract.type !== 'document'">
    <div class="item-label" i18n>Sign Location</div>
    <div class="item-value">
      {{ activities[signer.role]?.opened?.additional?.location | signLocation }}
    </div>
  </div>
  <div class="item-row" *ngIf="isSignable(signer)">
    <button
      i18n-matTooltip
      matTooltip="open sign editor for this signer."
      class="btn btn-secondary-primary"
      (click)="openSignEditor(signer)"
    >
      <i class="" [ngClass]="isGeneratingSignLink ? 'far fa-spin fa-spinner' : 'far fa-signature'"></i>
      <ng-container i18n>Sign Now</ng-container>
    </button>
  </div>
</div>
